var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEj20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.98,5.87h-.5s.02-3.57.02-3.57c0-.46-.37-.83-.82-.83-.46,0-.83.37-.83.82l-.02,3.57h-2.2s.02-3.58.02-3.58c0-.46-.37-.83-.82-.83-.46,0-.83.37-.83.82l-.02,3.57h-.5c-.57,0-1.03.45-1.03,1.02v.89c-.01,1.54.8,2.89,2.01,3.64,0,0,0,0,0,0,0,.02,0,.03,0,.05v.84c0,.81.63,1.48,1.43,1.54v5.89c0,1.16-.95,2.11-2.13,2.11s-2.11-.95-2.11-2.11v-2.94c0-1.3-.97-2.36-2.21-2.54V4.31c0-1.73-1.41-3.14-3.14-3.14H6.33c-1.73,0-3.14,1.41-3.14,3.14v21.02c0,.32.07.62.17.9H1.19C.54,26.23,0,26.76,0,27.42v.23C0,28.3.54,28.83,1.19,28.83h19.27c.65,0,1.19-.54,1.19-1.19v-.23c0-.65-.54-1.19-1.19-1.19h-2.18c.11-.28.17-.58.17-.9v-9.56c.41.15.71.54.71,1v2.94c0,1.99,1.62,3.61,3.63,3.61s3.61-1.62,3.61-3.61v-5.98c.58-.22,1.01-.78,1.01-1.44v-.59s0,0,0,0c1.51-.65,2.58-2.15,2.58-3.9v-.89c0-.57-.45-1.03-1.02-1.03Zm-12.66,7.5c0,.42-.32.77-.71.77H6.04c-.39,0-.71-.35-.71-.77v-6.76c0-.42.32-.77.71-.77h9.57c.39,0,.71.35.71.77v6.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEj20);
export default __webpack_public_path__ + "static/media/EJ20.f8255bd883ed17caf9d1421ae06744e1.svg";
export { ForwardRef as ReactComponent };